// import React from 'react'
// import GameCard from '../GameCard'
// import GifImagesSection from '../GifImagesSection'

// const CommonBox = ({heading,englishHeading,data}) => {
//     return (
//         <>
//             <section className='common-box-section lg:m-5 p-2.5 pb-0 lg:pb-2.5 lg:pt-[60px] lg:border lg:border-slate relative'>
//                 <h2 className='text-lg lg:text-[25px] font-bold lg:font-semibold shadow-[0px_1px_0px_rgba(255,255,255,0.1)] lg:shadow-none mb-[5px] lg:mb-0 shado h-[45px] lg:h-[50px] leading-[45px] lg:leading-[50px] bg-charcoal font-NotoSansKR ps-2.5 lg:ps-[15px] border-b-[2px] border-b-black lg:border-b-none lg:border-t-[2px] lg:border-t-indigoBlue text-skyblue lg:gradient-animation-text lg:absolute inset-0'> {heading} <small className='text-silver lg:hidden font-Time'>{englishHeading}</small> </h2>
//                 <div className='p-2.5'>
//                     <ul className='grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2.5 lg:gap-x-[20px] lg:gap-y-[25px] lg:p-2.5'>
//                         {data.map((item, index) => (

//                             <li className='' key={index}><GameCard imgSrc={item.imgSrc} gameTitle={item.title} englishGameTitle={item.englishTitle} /></li>
//                         ))}
//                     </ul>
//                 </div>
//             </section>


//         </>
//     )
// }

// export default CommonBox

import React from 'react'
const CommonBox = ({ heading, englishHeading, isEnglishHeadingOnMobile, isAuthenticated, children }) => {
    return (
        <>
            <div className='common-box-section lg:m-5 p-2.5 pb-0 lg:pb-2.5 lg:pt-[60px] lg:border lg:border-slate relative lg:min-h-[650px]'>
                <h2 className='text-lg lg:text-[25px] font-bold lg:font-semibold shadow-[0px_1px_0px_rgba(255,255,255,0.1)] lg:shadow-none mb-[5px] lg:mb-0 shado h-[45px] lg:h-[50px] leading-[45px] lg:leading-[50px] bg-charcoal font-NotoSansKR ps-2.5 lg:ps-[15px] border-b-[2px] border-b-black lg:border-b-none lg:border-t-[2px] lg:border-t-indigoBlue text-skyblue lg:gradient-animation-text lg:absolute inset-0'>
                    {isAuthenticated ?
                        <>
                            {heading}
                            {isEnglishHeadingOnMobile && <small className='hidden lg:inline font-thin text-[15px] lg:text-xl gradient-animation-text text-silver font-NotoSansKR'> {englishHeading}</small>}
                            <small className='text-silver lg:hidden text-[15px] font-Time'>{englishHeading}</small>
                        </>
                        : ''}
                </h2>
                {children}
            </div>


        </>
    )
}

export default CommonBox